export const programsMessages = {
  resources: {
    programs: {
      name: "Program |||| Programs",
      forcedCaseName: "Program",
      fields: {
        name: "Program name",
        season: "Season",
        description: "Description",
        starts_on: "Starts on",
        ends_on: "Ends on",
        active: "Active",
        created_at: "Created at",
      },
      action: {
        new: "New Program",
        create: "Create Program",
        edit: "Edit program",
        add_class: "Add class",
      },
      classes: "Classes",
      no_classes: "No classes in this program yet.",
      empty: {
        title: "No programs yet",
        description:
          'A program is what families sign up for, like "Fall Soccer 2026".',
      },
    },
  },
};
